import { useData, useDataAuth } from "../../../runtime/provider";
import { useQuery } from "@tanstack/react-query";
import { ReactQueryOptions } from "@utils/trpc";
import {
  gamificationSummaryQuery,
  gamificationSummaryQueryKey,
} from "./queryFunctions";

type QueryOptions = ReactQueryOptions["user"]["gamification"]["summary"];

export const useGamificationSummary = (options?: QueryOptions) => {
  const data = useData();
  const enabledFromAuth = !!useDataAuth().firebaseUser;

  return useQuery({
    ...gamificationSummaryQuery(data),
    ...options,
    enabled: enabledFromAuth && (options?.enabled ?? true),
  });
};

export { gamificationSummaryQueryKey };
